module.exports = __webpack_public_path__ + "img/15.28a59077.png";